export default {
    //会社員
    1: 14.6*12,
    //公務員
    2: 14.6*12,
    //自営業
    3: 5.6*12,
    //専業主婦/主夫
    4: 5.6*12,
}